import { createReducer, on } from "@ngrx/store";
import { Action } from "rxjs/internal/scheduler/Action";
import { Plant } from "src/model/class/general classes/plant";
import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import {
  currentPlantChangeConnectionAddressAction,
  currentPlantChangeDefaultSupervisionToOpenAction,
  currentPlantChangeSelectionAction,
  currentPlantChangeWanConnectionAction,
  currentPlantUnsetAction,
  plantAddAction,
  plantChangeWanAllowConnectionAction,
  plantDefaultSupervisionToOpenAction,
  plantOverwriteAction,
  plantRemoveAction,
  plantUpdateAction,
} from "../actions/plant.actions";

//#region Plant list
/**
 * Reducer plant creation
 */

/**
 * Memeber exportfor authentication reducer
 *
 * @param action
 * @param state
 * @returns
 */
export const PlantsReducer = createReducer(
  [],
  on(plantAddAction, (listPlant: Array<Plant>, action) => {
    return [...listPlant, action.newPlant];
  }),
  on(plantRemoveAction, (listPlant: Array<Plant>, action) => {
    return listPlant.filter((plant: Plant) => plant.ID !== action.idPlant);
  }),
  on(plantUpdateAction, (listPlant: Array<Plant>, action) => {
    return listPlant.map((plant: Plant) => {
      if (plant.ID === action.updatePlant.ID) {
        plant = action.updatePlant;
      }

      return plant;
    });
  }),
  on(plantOverwriteAction, (listPlant: Array<Plant>, action) => {
    return action.updatePlants;
  }),
  on(plantChangeWanAllowConnectionAction, (listPlant: Array<Plant>, action) => {
    return listPlant.map((plant: Plant) => {
      if (plant.ID === action.idPlant) {
        const allowWanConnection: boolean = plant.isWanFieldFilled
          ? action.allowWanConnection
          : false;

        plant = new Plant({
          ...plant,
          AllowWanConnection: allowWanConnection,
        });
      }

      return plant;
    });
  }),
  on(plantDefaultSupervisionToOpenAction, (listPlant: Array<Plant>, action) => {
    const defaultSupervisionToOpen: string =
      action.idSupervision.toString() + "," + action.idEnvironment.toString();

    return listPlant.map((plant: Plant) => {
      if (plant.ID === action.idPlant) {
        plant = new Plant({
          ...plant,
          defaultSupervision: defaultSupervisionToOpen,
        });
      }

      return plant;
    });
  })
);
//#endregion

/**
 * Current plant reducer
 *
 * @param action
 * @param state
 * @returns
 */
export const CurrentPlantReducer = createReducer(
  null,
  on(currentPlantChangeSelectionAction, (selectedPlant: Plant, action) => {
    return action.selectedPlant;
  }),
  on(currentPlantUnsetAction, (selectedPlant: Plant, action) => {
    return null;
  }),
  on(
    currentPlantChangeConnectionAddressAction,
    (selectedPlant: Plant, action) => {
      // aggiorno direttamente l'istanza senza spread
      const updatedPlant = new Plant({ ...selectedPlant, Endpoint: action.newAddressConnection });
      return updatedPlant;
    }
  ),
  on(
    currentPlantChangeWanConnectionAction,
    (selectedPlant: Plant, action) => {
      const allowWanConnection: boolean = selectedPlant.isWanFieldFilled
        ? action.allowWanConnection
        : false;

      return new Plant({ ...selectedPlant, AllowWanConnection: allowWanConnection });
    }
  ),
  on(
    currentPlantChangeDefaultSupervisionToOpenAction,
    (selectedPlant: Plant, action) => {
      const defaultSupervisionToOpen: string =
        action.idSupervision.toString() + "," + action.idEnvironment.toString();

      return new Plant({ ...selectedPlant, defaultSupervision: defaultSupervisionToOpen });
    }
  )
);
